import type { FormValues } from "$routes/patient/[:patientId]/investigations/new/validation-schema";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { LocationState } from "./types";

export const defaultValues: FormValues = {
  investigations: [],
};

export function useDefaultValues(): FormValues {
  const navigate = useNavigate();
  const location = useLocation();
  const values = (location.state as LocationState)?.values;

  // Clear the values from the history state after loading
  // to prevent stale state when refreshing the page
  useEffect(() => {
    if (values) {
      navigate(
        {
          ...location,
        },
        {
          state: undefined,
          replace: true,
        },
      );
    }
  }, [values, location, navigate]);

  return values ?? defaultValues;
}
